<script setup>
import { ref } from 'vue'
import { useGlobalStore } from '@stores/global.js'
import { register } from 'swiper/element/bundle'
import { Autoplay } from 'swiper/modules'
import Stamp from '@components/global/accents/Stamp.vue'
register()

const global = useGlobalStore()
const props = defineProps(['project', 'type'])

const breakpoints = ref({
	0: {
		slidesPerView: 3,
	},
	640: {
		slidesPerView: 3,
	},
	768: {
		slidesPerView: 3,
	},
	1024: {
		slidesPerView: 4,
	},
	1280: {
		slidesPerView: 4,
	},
	1536: {
		slidesPerView: 5,
	},
})
</script>

<template>
	<router-link :to="{ name: 'project', params: { slug: project.slug } }" class="group relative flex aspect-4/3 select-none flex-col items-start justify-end overflow-hidden bg-crowns-off-black p-7 transition-all duration-300 hover:sm:scale-102" v-if="type == 'tile'">
		<img class="absolute left-0 top-0 h-full w-full transition-opacity duration-300 group-hover:sm:opacity-30" :src="project.poster" :alt="project.name" />
		<div class="relative z-10 flex translate-y-6 flex-col gap-2 opacity-0 transition-all duration-300 ease-in-out group-hover:sm:translate-y-0 group-hover:sm:opacity-100">
			<span class="text-start text-xs font-semibold uppercase text-crowns-clouds xl:text-sm">Case Study</span>
			<div class="text-start font-alternate-gothic text-3xl uppercase leading-none xl:text-4xl">{{ project.name }}</div>
		</div>
	</router-link>
	<router-link :to="{ name: 'project', params: { slug: project.slug } }" class="group relative flex flex-col gap-8 sm:p-3" v-else-if="type == 'list'">
		<div class="absolute left-0 top-0 z-0 hidden h-full w-full rounded-xl opacity-0 transition-opacity duration-300 ease-linear sm:block group-hover:sm:opacity-100" :style="`background: linear-gradient(to top, ${project.client.accent_color} -200%, transparent 75%) `" />
		<div class="relative mb-5 flex grid-cols-12 flex-col gap-3 lg:grid">
			<div class="flex items-center justify-between lg:col-span-5">
				<div class="col-span-5 flex flex-col gap-4">
					<span class="text-start text-xs font-semibold uppercase text-crowns-castle-stone 2xl:text-sm">Case Study</span>
					<div class="w-4/5 text-start font-alternate-gothic text-4xl uppercase leading-[.9] 2xl:text-5xl 3xl:text-6xl">{{ project.name }}</div>
				</div>
				<div class="col-span-2 flex items-end justify-end gap-1 lg:hidden">
					<Stamp accent="#080808" :size="global.screenWidth > 1024 ? 'md' : 'sm'" />
					<Stamp :accent="project.client.accent_color" :size="global.screenWidth > 1024 ? 'md' : 'sm'">{{ project.client.stamp }}</Stamp>
				</div>
			</div>
			<div class="col-span-5 flex items-end">
				<p class="line-clamp-4 text-sm 2xl:line-clamp-none">{{ project.description }}</p>
			</div>
			<div class="col-span-2 hidden items-end justify-end gap-1 lg:flex">
				<Stamp accent="#080808" :size="global.screenWidth > 1024 ? 'md' : 'sm'" />
				<Stamp :accent="project.client.accent_color" :size="global.screenWidth > 1024 ? 'md' : 'sm'">{{ project.client.stamp }}</Stamp>
			</div>
		</div>
		<div class="overflow-hidden" v-if="project.images.length > 0">
			<div class="flex h-72 gap-4" style="animation: marquee 120s linear infinite">
				<img class="aspect-4/3 object-cover object-center" :src="image" alt="" v-for="image in project.images" :key="image" />
				<img class="aspect-4/3 object-cover object-center" :src="image" alt="" v-for="image in project.images" :key="image" />
				<img class="aspect-4/3 object-cover object-center" :src="image" alt="" v-for="image in project.images" :key="image" />
			</div>
		</div>
	</router-link>
</template>

<style>
@keyframes marquee {
	0% {
		transform: translate3d(0, 0, 0);
	}
	100% {
		transform: translate3d(-300%, 0, 0);
	}
}
</style>
